import React from 'react';
import LongText from '../../Elements/LongText';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';
import JsxHelper from '../../Helpers/JsxHelper';
import DataTableActionMenu from '../../Elements/DataTable/DataTableActionMenu';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import TemplateVariantAdmin from '../../Contents/Administration/Templates/TemplateVariantAdmin';

// One row of the Templates list: every stored template sharing a name, summarized.
export default class TemplateGroupItem {
  constructor(item) {
    if (item === undefined) {
      this.Name = '';
      this.Description = '';
      this.Locale = '';
      this.LocaleCount = 0;
      this.VariantCount = 0;
      this.NewestTemplateId = null;
      this.NewestVersion = 0;
      this.Type = '';
      this.IsActive = false;
      this.IsStringContent = false;
      return;
    }

    this.Name = item.name;
    this.Description = item.description;
    this.Locale = item.locale;
    this.LocaleCount = item.localeCount;
    this.VariantCount = item.variantCount;
    this.NewestTemplateId = item.newestTemplateId;
    this.NewestVersion = item.newestVersion;
    this.Type = item.type;
    this.IsActive = item.isActive;
    this.IsStringContent = item.isStringContent;
  }

  static displayedInList = 'Name';

  static NameOfTheIdField() {
    return 'Name';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateOnlyFields = [];

  static DateFields = [];

  static BoolFields = [];

  static nameOfTheItemDetailList(item) {
    if (item)
      return (
        <span>
          Template -{' '}
          <LongText
            text={item.Name}
            maxLength={40}
          />
        </span>
      );
    return 'Template';
  }

  // Edit reaches every language and version. Upload and download need one file, so they take the
  // newest version of a single-language template and are disabled otherwise.
  static getActionsContent(item) {
    const hasSingleLocale = item.LocaleCount === 1 && item.NewestTemplateId !== null;
    const multiLocaleTooltip = 'This template has more than one language. Open it and use the Variants tab.';

    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => TemplateGroupItem.editFunction(item),
            tooltipText: 'Edit the description and active state of every language of this template',
          },
          {
            // Same gate as upload and download: with more than one language there is no single file
            // to act on. Only offered at all for a template kept as text.
            iconName: 'fa-solid fa-code',
            text: 'Edit Content',
            onClick: () => TemplateGroupItem.editContentFunction(item),
            disabled: !hasSingleLocale,
            hide: !item.IsStringContent,
            tooltipText: hasSingleLocale
              ? 'Edit the newest version of this template and see how it looks'
              : multiLocaleTooltip,
          },
          {
            iconName: 'fa-solid fa-upload',
            text: 'Upload New Version',
            onClick: () => TemplateGroupItem.uploadFunction(item),
            disabled: !hasSingleLocale,
            tooltipText: hasSingleLocale ? 'Store a new version of this template' : multiLocaleTooltip,
          },
          {
            iconName: 'fa-solid fa-download',
            text: 'Download',
            onClick: () => TemplateGroupItem.downloadFunction(item),
            disabled: !hasSingleLocale,
            tooltipText: hasSingleLocale ? 'Download the newest version' : multiLocaleTooltip,
          },
        ]}
      />
    );
  }

  static editFunction = (item) => {
    alert('Empty function');
  };

  static editContentFunction = (item) => {
    alert('Empty function');
  };

  static uploadFunction = (item) => {
    alert('Empty function');
  };

  static downloadFunction = (item) => {
    alert('Empty function');
  };

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Name',
        orderById: 'Name',
        data: 'Name',
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      { label: 'Description', orderById: 'Description', data: 'Description' },
      { label: 'Language', orderById: 'Locale', data: 'Locale' },
      { label: 'Languages', orderById: 'LocaleCount', data: 'LocaleCount' },
      { label: 'Variants', orderById: 'VariantCount', data: 'VariantCount' },
      { label: 'Data Type', orderById: 'Type', data: 'Type' },
      {
        label: 'Active',
        orderById: 'IsActive',
        data: (item) => JsxHelper.YesNo(item.IsActive),
        type: FieldTypesEnum.Bool,
      },
      {
        label: ' ',
        orderById: 'Name',
        data: TemplateGroupItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'Name', label: 'Name' },
        { name: 'Description', label: 'Description' },
        { name: 'Locale', label: 'Language' },
        { name: 'Type', label: 'Data Type' },
        { name: 'LocaleCount', label: 'Language Variants' },
        { name: 'VariantCount', label: 'Total Variants' },
      ],
    },
    {
      tabName: 'Variants',
      tabLabel: 'Variants',
      icon: 'fa-solid fa-layer-group',
      data: [
        {
          name: TemplateGroupItem.getVariantsContent,
          label: 'Variants',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static getVariantsContent(item) {
    return <TemplateVariantAdmin templateName={item.Name} />;
  }
}
